<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-general />
      </div>
    </vs-tab>
    <vs-tab
      v-if="hasPermission('life.admin.user.roles.show')"
      icon-pack="feather"
      icon="icon-shield"
      :label="!isSmallerScreen ? 'Roles' : ''"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-roles />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Venues' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-venues />
      </div>
    </vs-tab>
    <vs-tab
      v-if="hasPermission('life.admin.user.skills.show')"
      icon-pack="feather"
      icon="icon-star"
      :label="!isSmallerScreen ? 'Skills' : ''"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-skills />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserGeneral from "./UserGeneral.vue";
import UserVenues from "./UserVenues.vue";
import UserSkills from "./UserSkills.vue";
import UserRoles from "./UserRoles.vue";

export default {
  components: {
    UserGeneral,
    UserVenues,
    UserRoles,
    UserSkills,
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
